import {
	Dimensions,
	Platform
} from 'react-native';


export enum SCREEN_SIZE {
	/**
	 * Screen Width <576px
	 */
	X_SMALL = 'extra_small',

	/**
	 * Screen Width >=576px
	 */
	SMALL = 'small',

	/**
	 * Screen Width >=768px
	 */
	MEDIUM = 'medium',

	/**
	 * Screen Width >=992px
	 */
	LARGE = 'large',

	/**
	 * Screen Width >=1200px
	 */
	X_LARGE = 'extra_large',
}

export const getScreenType = (
	screenWidth?: number,
): SCREEN_SIZE => {
	const screenWidthX =
		screenWidth || Dimensions.get('window').width;
	if (screenWidthX < 576)
		return SCREEN_SIZE.X_SMALL;
	if (screenWidthX < 768) return SCREEN_SIZE.SMALL;
	if (screenWidthX < 992)
		return SCREEN_SIZE.MEDIUM;
	if (screenWidthX < 1200)
		return SCREEN_SIZE.LARGE;
	if (screenWidthX >= 1200)
		return SCREEN_SIZE.X_LARGE;

	return SCREEN_SIZE.X_SMALL;
};
export const isMobile = (
	screenType: SCREEN_SIZE,
) =>
	screenType === SCREEN_SIZE.X_SMALL ||
	screenType === SCREEN_SIZE.SMALL;



export const isMobileView = () => {
		const Breakpoint = 1024
		if (Platform.OS === 'web') {
			if (window?.outerWidth < Breakpoint) {
				return true
			} else {
				return false
			}
		}
		return true
}

export const isMobileViewApp = () => {
	const Breakpoint = 1024
	if (Platform.OS === 'web') {
		if (window?.innerWidth < Breakpoint) {
			return true
		} else {
			return false
		}
	}
	return true
}




const PLATFORM_PADDING: number = 16 * 2;
const DESKTOP_WIDTH: number = 508;



export const _getUiWindow: (
	screenSize: number,
) => number = (screenSize) =>
	isMobile(getScreenType(screenSize))
		? screenSize - PLATFORM_PADDING
		: DESKTOP_WIDTH - PLATFORM_PADDING;


export const addCommasToNumber = (
	num: number,
) => {
	return num
		.toString()
		.replace(
			/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g,
			',',
		);
};


export const addSuffix = (day) => {
	if (day >= 11 && day <= 13) {
		return 'th';
	}
	switch (day % 10) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};

export const getDateMonthYearFromEpoch = (epochNumber?: number) => {
	const newDateToPick = new Date(epochNumber)
	const displayDate = newDateToPick.getDate()
	const dateName = `${displayDate}${addSuffix(displayDate)}`
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
		"July", "Aug", "Sept", "Oct", "Nov", "Dec"
	];
	const getMonthName = newDateToPick.getMonth()
	const currentYear = newDateToPick.getFullYear();
	return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`

}

